/* eslint-disable no-param-reassign */
/* eslint-disable import/no-extraneous-dependencies */
import 'Pods/Shared/suppressClockWarning'

import React from 'react'

import { Canvas } from '@react-three/fiber'
import { CineonToneMapping } from 'three'

import { ContactShadows } from './ContactShadows'
import { Model } from './Model'
import { Postprocessing } from './Postprocessing'
import { Stage } from './Stage'
import { useViewerContext, ViewerProvider } from '../context/ViewerProvider'
import { isLowQuality } from '../helpers/qualityCheck'

export function Viewer() {
  const [viewerState, viewerDispatch] = useViewerContext()
  const { isLoad } = viewerState

  return (
    <Canvas
      camera={{ fov: 30 }}
      dpr={window.devicePixelRatio}
      gl={{
        alpha: true,
        antialias: false,
      }}
      style={{ position: 'absolute', background: 'transparent' }}
      onCreated={({ gl, scene }) => {
        scene.background = null
        gl.setClearColor(0x000000, 0)
        gl.toneMapping = CineonToneMapping
        gl.toneMappingExposure = 1
      }}
    >
      <ViewerProvider reducer={[viewerState, viewerDispatch]}>
        <Stage intensity={1} adjustCamera preset="portrait">
          <Model />
        </Stage>
        {isLoad && !isLowQuality() && <ContactShadows width={1} height={1} scale={40} blur={3} frames={5} />}
        {isLoad && <Postprocessing />}
      </ViewerProvider>
    </Canvas>
  )
}
